import { Navigate } from 'react-router-dom';

export const Dashboard = () => <Navigate to='/front/my-companies' />;
